/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFlagUsa} from '@fortawesome/pro-duotone-svg-icons';

const LanguageCitizenshipIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFlagUsa} {...props} />
);

export default LanguageCitizenshipIcon;
